export class Unit {
    Id: number;
    Code: number;
    Description: string;
}
